import { ChangeDetectionStrategy, Component, Inject, Optional } from "@angular/core";
import { TABLE_CUSTOM_TEMPLATE_CONTEXT } from "src/app/common/components/table/tokens/table-custom-template-context";
import { kwpBadges } from "../../constants/kwp-badges";

@Component({
  selector: "app-notification-settings-kwp-cell",
  styleUrls: ["./notification-settings-kwp-cell.component.scss"],
  templateUrl: "./notification-settings-kwp-cell.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationSettingsKWPCellComponent {
  public badges = Object.values(kwpBadges);

  constructor(@Optional() @Inject(TABLE_CUSTOM_TEMPLATE_CONTEXT) public readonly context: { id: string; row: any }) {
    this.badges = this.badges.filter(({ type }) => context.row.notifyByEmail?.[type]);
  }
}
